import { render, staticRenderFns } from "./PaymentsSubscriptionView.vue?vue&type=template&id=0b78fda6&scoped=true"
import script from "./PaymentsSubscriptionView.vue?vue&type=script&lang=js"
export * from "./PaymentsSubscriptionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b78fda6",
  null
  
)

export default component.exports